import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class ContractsAdapter {
  private http = inject(HttpClient);

  getContracts(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/company/contracts`);
  }
}
